import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f4f4f4',
    borderRadius: 25,
    padding: 4,
    gap: 2,
    width: 'fit-content',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    height: 35,
    margin: '0 auto 0 8px',
    border: '1px solid #a0a0a0',
    boxSizing: 'border-box',
    scale: 0.8,
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      marginBottom: 14,
    },
  },
  switchOption: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50%',
    maxWidth: 65,
    cursor: 'pointer',
    borderRadius: 20,
    height: 23,
    position: 'relative',
    zIndex: 1,
    transition: 'all 0.3s ease',
    gap: 6,
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      '&:after': {
        content: '""',
        position: 'absolute',
        top: '-15px',
        left: '-15px',
        right: '-15px',
        bottom: '-15px',
        zIndex: -1,
      },
    },
    '&:not($activePlatform)': {
      opacity: 0.6,
      filter: 'grayscale(0.3)',
      scale: 0.7,
    },
  },
  activePlatform: {
    boxShadow: '0 3px 8px rgb(150 150 150 / 69%)',
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #e3e3e3',
    borderRadius: '50%',
  },
  icon: {
    width: 25,
    height: 25,
    objectFit: 'contain',
  },
}));
